// Sun Clip Color Selector
// Converted from ES6 module to IIFE for Shopify compatibility
(function() {
    'use strict';

    window.SunClipColorSelector = function() {
        this.currentCategory = 'solid';
        this.selectedColors = {
            lens: null,
            bridge: null,
            magnet: null,
            crystal: null
        };

        return this;
    };

    window.SunClipColorSelector.prototype = {
        initialize: function(containerId, colorData) {
            this.lensContainer = document.getElementById(containerId);
            this.colorData = colorData;
            this.displayCategory('solid'); // Start with solid colors
        },

        initializeBridges: function(containerId, bridgeData) {
            const container = document.getElementById(containerId);
            this.renderBridgeOptions(container, bridgeData);
        },

        initializeMagnets: function(containerId, magnetData) {
            const container = document.getElementById(containerId);
            this.renderMagnetOptions(container, magnetData);
        },

        initializeCrystals: function(containerId, crystalData) {
            const container = document.getElementById(containerId);
            this.renderCrystalOptions(container, crystalData);
        },

        displayCategory: function(category) {
            this.currentCategory = category;

            if (!this.lensContainer || !this.colorData) return;

            const colors = this.colorData[category];
            if (!colors) return;

            this.lensContainer.innerHTML = '';

            colors.forEach(color => {
                const colorElement = this.createColorSwatch(color, 'lens');
                this.lensContainer.appendChild(colorElement);
            });
        },

        createColorSwatch: function(colorData, type) {
            const container = document.createElement('div');
            container.className = 'color-swatch-container';

            const swatch = document.createElement('div');
            swatch.className = 'color-swatch';
            swatch.dataset.colorId = colorData.id;
            swatch.dataset.type = type;

            // Set background based on color type
            if (colorData.gradient) {
                swatch.style.background = `linear-gradient(135deg, ${colorData.gradient.join(', ')})`;
            } else if (colorData.hex) {
                swatch.style.backgroundColor = colorData.hex;
            } else {
                // Use placeholder for missing colors
                swatch.classList.add('color-puck-placeholder');
            }

            // Add mirror effect styling
            if (colorData.mirror) {
                swatch.classList.add('mirror-swatch');
                swatch.style.background = `
                    linear-gradient(135deg,
                        ${colorData.hex} 0%,
                        ${this.lightenColor(colorData.hex, 30)} 50%,
                        ${colorData.hex} 100%
                    )
                `;
                swatch.style.boxShadow = `
                    inset 0 1px 0 rgba(255,255,255,0.8),
                    inset 0 -1px 0 rgba(0,0,0,0.3)
                `;
            }

            // Add event listeners
            swatch.addEventListener('click', () => {
                this.selectColor(colorData, type);
            });

            swatch.addEventListener('mouseenter', () => {
                this.showColorInfo(colorData);
            });

            swatch.addEventListener('mouseleave', () => {
                this.hideColorInfo();
            });

            // Add color name label
            const label = document.createElement('span');
            label.className = 'color-puck-label';
            label.textContent = this.formatColorName(colorData.id);

            container.appendChild(swatch);
            container.appendChild(label);

            return container;
        },

        renderBridgeOptions: function(container, bridgeData) {
            container.innerHTML = '';

            bridgeData.forEach(bridge => {
                const option = document.createElement('div');
                option.className = 'option-card';
                option.dataset.colorId = bridge.id;
                option.dataset.type = 'bridge';

                option.innerHTML = `
                    <div class="bridge-preview" style="background-color: ${bridge.hex}">
                        <svg width="100" height="20" viewBox="0 0 100 20">
                            <path d="M10,10 Q50,5 90,10"
                                  stroke="${bridge.hex}"
                                  stroke-width="3"
                                  fill="none"/>
                        </svg>
                    </div>
                    <div class="option-name">${bridge.name}</div>
                `;

                option.addEventListener('click', () => {
                    this.selectColor(bridge, 'bridge');
                });

                container.appendChild(option);
            });
        },

        renderMagnetOptions: function(container, magnetData) {
            container.innerHTML = '';

            magnetData.forEach(magnet => {
                const option = document.createElement('div');
                option.className = 'option-card';
                option.dataset.colorId = magnet.id;
                option.dataset.type = 'magnet';

                option.innerHTML = `
                    <div class="magnet-preview">
                        <div class="magnet-circle" style="background: radial-gradient(circle, ${magnet.hex} 0%, ${this.darkenColor(magnet.hex, 20)} 100%)">
                            <div class="magnet-center"></div>
                        </div>
                    </div>
                    <div class="option-name">${magnet.name}</div>
                `;

                option.addEventListener('click', () => {
                    this.selectColor(magnet, 'magnet');
                });

                container.appendChild(option);
            });
        },

        renderCrystalOptions: function(container, crystalData) {
            container.innerHTML = '';

            crystalData.forEach(crystal => {
                const option = document.createElement('div');
                option.className = 'option-card';
                option.dataset.colorId = crystal.id;
                option.dataset.type = 'crystal';

                if (crystal.id === 'none') {
                    option.innerHTML = `
                        <div class="crystal-preview no-crystal">
                            <div class="no-crystal-text">No Crystal</div>
                        </div>
                        <div class="option-name">None</div>
                    `;
                } else {
                    option.innerHTML = `
                        <div class="crystal-preview">
                            <div class="crystal-gem" style="background: ${this.getCrystalGradient(crystal.hex)}">
                                <div class="crystal-facets"></div>
                            </div>
                        </div>
                        <div class="option-name">${crystal.name}</div>
                        ${crystal.price > 0 ? `<div class="option-price">+$${crystal.price}</div>` : ''}
                    `;
                }

                option.addEventListener('click', () => {
                    this.selectColor(crystal, 'crystal');
                });

                container.appendChild(option);
            });
        },

        selectColor: function(colorData, type) {
            // Haptic feedback for mobile devices
            if (window.navigator && window.navigator.vibrate) {
                window.navigator.vibrate(10);
            }

            // Remove previous selection
            document.querySelectorAll(`.option-card[data-type="${type}"], .color-swatch[data-type="${type}"]`)
                .forEach(el => el.classList.remove('selected'));

            // Add selection to clicked element
            const selectedElement = document.querySelector(
                `[data-color-id="${colorData.id}"][data-type="${type}"]`
            );
            if (selectedElement) {
                selectedElement.classList.add('selected');
            }

            // Store selection
            this.selectedColors[type] = colorData.id;

            // Show color description for lens colors
            if (type === 'lens') {
                this.showColorInfo(colorData, true);
            }

            // Dispatch custom event
            const event = new CustomEvent('colorSelected', {
                detail: {
                    type,
                    value: colorData.id,
                    category: this.currentCategory,
                    colorData: colorData
                }
            });

            window.dispatchEvent(event);
        },

        showColorInfo: function(colorData, persist) {
            const nameEl = document.getElementById('colorName');
            const descEl = document.getElementById('colorDescription');

            if (nameEl && descEl) {
                nameEl.textContent = colorData.name;
                descEl.textContent = colorData.description;

                if (!persist) {
                    // Auto-hide after 3 seconds if not persisted
                    setTimeout(() => {
                        if (nameEl.textContent === colorData.name) {
                            this.hideColorInfo();
                        }
                    }, 3000);
                }
            }
        },

        hideColorInfo: function() {
            const nameEl = document.getElementById('colorName');
            const descEl = document.getElementById('colorDescription');

            if (nameEl && descEl) {
                // Only hide if it's not a selected color
                const hasSelection = Object.values(this.selectedColors).some(v => v !== null);
                if (!hasSelection) {
                    nameEl.textContent = 'Select a color';
                    descEl.textContent = 'Choose from our premium lens colors';
                }
            }
        },

        // Helper methods for color manipulation
        lightenColor: function(hex, percent) {
            const num = parseInt(hex.replace("#", ""), 16);
            const amt = Math.round(2.55 * percent);
            const R = (num >> 16) + amt;
            const G = (num >> 8 & 0x00FF) + amt;
            const B = (num & 0x0000FF) + amt;

            return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
                (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
                (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
        },

        darkenColor: function(hex, percent) {
            const num = parseInt(hex.replace("#", ""), 16);
            const amt = Math.round(2.55 * percent);
            const R = (num >> 16) - amt;
            const G = (num >> 8 & 0x00FF) - amt;
            const B = (num & 0x0000FF) - amt;

            return "#" + (0x1000000 + (R > 0 ? R : 0) * 0x10000 +
                (G > 0 ? G : 0) * 0x100 + (B > 0 ? B : 0)).toString(16).slice(1);
        },

        getCrystalGradient: function(baseColor) {
            const lightColor = this.lightenColor(baseColor, 40);
            const darkColor = this.darkenColor(baseColor, 20);

            return `
                linear-gradient(45deg,
                    ${lightColor} 0%,
                    ${baseColor} 30%,
                    ${darkColor} 70%,
                    ${baseColor} 100%
                )
            `;
        },

        formatColorName: function(colorName) {
            if (!colorName || colorName === 'none') return colorName;
            // Convert camelCase to readable format by adding spaces before capital letters
            return colorName.replace(/([A-Z])/g, ' $1').trim();
        },

        // Public methods for external access
        getSelectedColors: function() {
            const result = {};
            for (const key in this.selectedColors) {
                result[key] = this.selectedColors[key];
            }
            return result;
        },

        setSelectedColor: function(type, colorId) {
            // Find color data and simulate selection
            let colorData = null;

            switch (type) {
                case 'lens':
                    for (const category of Object.values(this.colorData)) {
                        colorData = category.find(c => c.id === colorId);
                        if (colorData) break;
                    }
                    break;
                // Add cases for other types as needed
            }

            if (colorData) {
                this.selectColor(colorData, type);
            }
        },

        clearSelection: function(type) {
            this.selectedColors[type] = null;

            document.querySelectorAll(`[data-type="${type}"]`)
                .forEach(el => el.classList.remove('selected'));

            if (type === 'lens') {
                this.hideColorInfo();
            }
        },

        clearAllSelections: function() {
            const self = this;
            Object.keys(this.selectedColors).forEach(function(type) {
                self.clearSelection(type);
            });
        }
    };

    // Compatibility aliases
    window.ColorSelector = window.SunClipColorSelector;  // Legacy alias
    window.ConfiguratorUI = window.SunClipColorSelector;  // New generic name (renamed from sun-clip-color-selector.js)

})();
// Updated: Added label container and formatColorName method

